import { Middleware, isRejectedWithValue } from '@reduxjs/toolkit';

export const sessionMiddleware: Middleware = (store) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const payload = action.payload as string;
    
    // If any API call returns SESSION_EXPIRED or Unauthorized, auto-logout
    if (payload === 'SESSION_EXPIRED' || payload === 'Unauthorized') {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      store.dispatch({ type: 'auth/sessionExpired' });
    }
  }
  
  return next(action);
};
